export default {
  components: {
    OwnershipGridForm: {
      ownersBeneficiaries: 'Nom des bénéficiaires',
      ownersHolders: 'Nom des détenteurs',
      fullOwnershipPct: '%. Pleine Propriété',
      usufructPct: '%. Usufruit',
      bareOwnership: '%. Nue-propriété',
    },
    TransmissionImpactIndicatorSimulation: {
      transmittedPatrimony: 'Patrimoine transmis net de fiscalité',
      fiscalCost: 'Coût fiscal de la transmission',
      fiscalPressure: 'Pression fiscale',
    },
    TransmissionSelectScenario: {
      title: 'Choix de scénario',
      hint: ''
    }
  },
}
